import React, { Component } from 'react';
import Modal from 'react-modal'; //npm install --save react-modal
import { getRequestParams, formatDate } from '../../helpers/globalfunctions.js';
import { LoadPanel } from 'devextreme-react/load-panel';
import { SelectBox } from 'devextreme-react/select-box';
import Swal from 'sweetalert2';
import { SendEmailComponent } from '../Shared/SendEmailComponent'

const currentYear = new Date().getFullYear();
const pastYear = new Date().getFullYear() - 5;
const currentMonth = new Date().getMonth() + 1;

const monthsDropdown = [
    { id: 1, name: 'January' },
    { id: 2, name: 'February' },
    { id: 3, name: 'March' },
    { id: 4, name: 'April' },
    { id: 5, name: 'May' },
    { id: 6, name: 'June' },
    { id: 7, name: 'July' },
    { id: 8, name: 'August' },
    { id: 9, name: 'Septmber' },
    { id: 10, name: 'October' },
    { id: 11, name: 'November' },
    { id: 12, name: 'December' },
];

let currentYearIndex = 0, index = 0;
const yearsDropdown = [];
for (let i = pastYear; i < currentYear + 5; i++) {
    let yearobject = new Object();
    if (i == currentYear) {
        currentYearIndex = index;
    }
    yearobject.id = i;
    yearobject.name = i.toString();
    yearsDropdown.push(yearobject);
    index++;
}

export class EstimateReimbursementReportComponent extends Component {
    constructor() {
        super()
        this.state = {
            isSubmitted: false,
            isEmailSubmitted: false,
            isOpenModal: false,
            loadPanelVisible: false,
            radVehicle: "0",
            vehicleList: [],
            vehicleId: 0,
            vehicleName: "",
            monthsList: monthsDropdown,
            selMonth: monthsDropdown[currentMonth-1],
            yearsList: yearsDropdown,
            selYear: yearsDropdown[currentYearIndex],
            errors: {
                vehicleId: 0,
            }
        }

        this.getVehicles = this.getVehicles.bind(this);

        this.handleRadVehicleChange = this.handleRadVehicleChange.bind(this);
        this.handleVehicleChange = this.handleVehicleChange.bind(this);
        this.handleMonthChange = this.handleMonthChange.bind(this);
        this.handleYearChange = this.handleYearChange.bind(this);

        this.handleEstimateReimbursementReportSubmit = this.handleEstimateReimbursementReportSubmit.bind(this);
        this.downloadEstimateReimbursementAsPdf = this.downloadEstimateReimbursementAsPdf.bind(this);
        this.handleClearSearch = this.handleClearSearch.bind(this);
    }
    async componentDidMount() {
        await this.getVehicles();
    }
    showModal = async () => {
        try {
            this.setState({ isOpenModal: true });
        } catch (ex) {
            console.log(ex);
        }
    }
    async getVehicles() {
        try {
            const requestParams = getRequestParams('GET', {});
            const response = await fetch('/vehicle-api/dropdown-all', requestParams);
            const data = await response.json();
            this.setState({
                vehicleList: data.vehiclesDropdown,
            });
        } catch (e) {
            console.log(e);
        }
    }
    handleMonthChange(e) {
        if (e != null) {
            this.setState({ selMonth: (e.selectedItem != null ? e.selectedItem : []) })
        }
        else {
            this.setState({ selMonth: monthsDropdown[currentMonth-1] })
        }
    }
    handleYearChange(e) {
        if (e != null) {
            this.setState({ selYear: (e.selectedItem != null ? e.selectedItem : []) })
        }
        else {
            this.setState({ selYear: yearsDropdown[currentYearIndex] })
        }
    }
    handleRadVehicleChange(e) {
        if (e.target.value == "0") {
            this.setState({
                radVehicle: e.target.value,
                vehicleId: 0,
                vehicleName: "",
            });
        }
        else if (e.target.value == "1") {
            this.setState({
                radVehicle: e.target.value,
            });
        }
        this.setState({ radVehicle: e.target.value });
    }
    handleVehicleChange(e) {
        if (e !== null) {
            this.setState({
                vehicleId: (e.selectedItem != null ? e.selectedItem.id : 0),
                vehicleName: (e.selectedItem != null ? e.selectedItem.name : ""),
            });
        }
        else {
            this.setState({
                vehicleId: 0,
                vehicleName: "",
            });
        }
    }
    handleOnAfterOpenModal = async () => {
        try {
            this.setState({ loadPanelVisible: true });
            await this.getCustomerList();
        } catch (ex) {
            console.log(ex);
        }
        this.setState({ loadPanelVisible: false });
    }
    handleOnCloseModal = async () => {
        try {
            this.setState({
                isSubmitted: false,
                isEmailSubmitted: false,
                isOpenModal: false,
                loadPanelVisible: false,
                radVehicle: "0",
                vehicleId: 0,
                vehicleName: "",
                monthsList: monthsDropdown,
                selMonth: monthsDropdown[currentMonth-1],
                yearsList: yearsDropdown,
                selYear: yearsDropdown[currentYearIndex],
                errors: {
                    vehicleId: 0,
                }
            });
        } catch (ex) {
            console.log(ex);
        }
    }
    handleValidation() {
        let errors = this.state.errors;
        let formIsValid = true;

        errors.vehicleId = 0;

        if (this.state.radVehicle == "1") {
            if (this.state.vehicleId == 0) {
                formIsValid = false;
                errors.vehicleId = "Please select vehicle";
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }
    handleEstimateReimbursementReportSubmit(e) {
        e.preventDefault();
        this.downloadEstimateReimbursementAsPdf(e);
    }
    async downloadEstimateReimbursementAsPdf(e) {
        e.preventDefault();
        if (this.handleValidation()) {
            try {
                this.setState({
                    //loadPanelVisible: true,
                    isSubmitted: true,
                });

                let reportHeader = "";
                reportHeader = "For Reimbursement month : " + this.state.selMonth.name + " " + this.state.selYear.name;

                if (this.state.radVehicle = "0") {
                    reportHeader = reportHeader + ", for all Vehicles";
                }
                else {
                    reportHeader = reportHeader + ", for Vehicle " + this.state.vehicleName;
                }

                let payDate = this.state.selYear.name + "-" + this.state.selMonth.id + "-01";

                var request = new Object();
                request.LocationId = Number(sessionStorage.getItem("session_locationId"));
                request.fileFormat = 'pdf';
                request.MethodName = "GetEstimateReimbursement";
                request.VehicleId = this.state.vehicleId;
                request.PayPeriodDate = payDate;
                request.Header = reportHeader;

                const requestParams = getRequestParams('POST', request);
                const response = await fetch('crystal-report-api', requestParams);
                const dataResponse = await response.json();
                this.setState({
                    // loadPanelVisible: false,
                    isSubmitted: false,
                });
                let a = document.createElement('a');
                a.href = dataResponse.reportBase64String;
                a.download = 'EstimateReimbursement.pdf';
                a.click();
            } catch (e) {

            }
        }
    }
    handleClearSearch() {
        this.setState({
            isSubmitted: false,
            isEmailSubmitted: false,
            isOpenModal: true,
            loadPanelVisible: false,
            radVehicle: "0",
            vehicleId: 0,
            vehicleName: "",
            monthsList: monthsDropdown,
            selMonth: monthsDropdown[currentMonth-1],
            yearsList: yearsDropdown,
            selYear: yearsDropdown[currentYearIndex],
            errors: {
                vehicleId: 0,
            }
        });
    }
    handleOnSendEmail = async (event) => {
        event.preventDefault();
        try {
            if (this.handleValidation()) {
                this.setState({ isEmailSubmitted: true });
                let reportHeader = "";
                reportHeader = "For Reimbursement month : " + this.state.selMonth.name + " " + this.state.selYear.name;

                if (this.state.radVehicle = "0") {
                    reportHeader = reportHeader + ", for all Vehicles";
                }
                else {
                    reportHeader = reportHeader + ", for Vehicle " + this.state.vehicleName;
                }

                let payDate = this.state.selYear.name + "-" + this.state.selMonth.id + "-01";

                var request = new Object();
                request.LocationId = Number(sessionStorage.getItem("session_locationId"));
                request.fileFormat = 'pdf';
                request.MethodName = "GetEstimateReimbursement";
                request.VehicleId = this.state.vehicleId;
                request.PayPeriodDate = payDate;
                request.Header = reportHeader;

                const requestParams = getRequestParams('POST', request);
                const response = await fetch('crystal-report-api', requestParams);
                const dataResponse = await response.json();
                this.setState({ isEmailSubmitted: false });
                let fileData = dataResponse.reportBase64String;
                if (fileData !== null && fileData !== '') {
                    let emailSubject = 'Estimate Reimbursement';
                    let attachments = [];
                    let file = new Object();
                    file.fileData = fileData;
                    file.fileName = 'EstimateReimbursement.pdf';
                    file.fileExtension = '.pdf';
                    attachments.push(file);
                    this.refs.sendEmailComponent.showModal('', '', emailSubject, '', attachments);
                }
                else {
                    Swal.fire({
                        allowOutsideClick: false,
                        showCloseButton: true,
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong! Unable to process the email request.',
                    })
                }
            }
        } catch (ex) {
            console.log(ex);
        }
        this.setState({ isEmailSubmitted: false });
    }
    render() {
        return (
            <div>
                <Modal ariaHideApp={false}
                    isOpen={this.state.isOpenModal}
                    style={{ content: { width: '40%' } }}
                    className={"react-modal"}
                    onAfterOpen={this.handleOnAfterOpenModal}
                    onRequestClose={this.handleOnCloseModal}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal">
                    <form method="post" onSubmit={this.handleOnReportSubmit}
                        style={(this.state.isSubmitted || this.state.isEmailSubmitted) ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                        <div className="modal-header">
                            <h6 className="modal-title">{'Estimate Reimbursement'}</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.handleOnCloseModal}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <div className="form-group">
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="radVehicle" value="0" checked={this.state.radVehicle === "0"} onChange={this.handleRadVehicleChange} />
                                            <label className="form-check-label">All Vehicle</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="radVehicle" value="1" checked={this.state.radVehicle === "1"} onChange={this.handleRadVehicleChange} />
                                            <label className="form-check-label">Single Vehicle</label>
                                        </span>
                                        <SelectBox
                                            dataSource={this.state.vehicleList.length > 0 ? this.state.vehicleList : []}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select vehicle"
                                            name="id"
                                            defaultValue={[]}
                                            value={this.state.vehicleId === 0 ? [] : [this.state.vehicleList.find(opt => opt.id === this.state.vehicleId)]}
                                            displayExpr='name'
                                            valueExpr='id'
                                            onSelectionChanged={this.handleVehicleChange}
                                            showClearButton={true}
                                            disabled={this.state.radVehicle === "1" ? false : true}
                                            searchEnabled={true}
                                        />
                                        {this.state.errors["vehicleId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["vehicleId"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="form-group">
                                        <label htmlFor="">Month</label>
                                        <SelectBox
                                            dataSource={this.state.monthsList.length > 0 ? this.state.monthsList : []}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select month"
                                            name="id"
                                            defaultValue={[]}
                                            value={this.state.selMonth.id == 0 ? [] : [this.state.monthsList.find(opt => opt.id == this.state.selMonth.id)]}
                                            displayExpr='name'
                                            valueExpr='id'
                                            onSelectionChanged={this.handleMonthChange}
                                            showClearButton={true}
                                            disabled={false}
                                            searchEnabled={true}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="form-group">
                                        <label>Year</label>
                                        <SelectBox
                                            dataSource={this.state.yearsList.length > 0 ? this.state.yearsList : []}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select year"
                                            name="id"
                                            defaultValue={[]}
                                            value={this.state.selYear.id == 0 ? [] : [this.state.yearsList.find(opt => opt.id == this.state.selYear.id)]}
                                            displayExpr='name'
                                            valueExpr='id'
                                            onSelectionChanged={this.handleYearChange}
                                            showClearButton={true}
                                            disabled={false}
                                            searchEnabled={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-success btn-sm" onClick={this.handleOnSendEmail} >
                                {this.state.isEmailSubmitted && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isEmailSubmitted && <span title="Send Email"><i className="fas fa-envelope"></i> Send Email</span>}
                            </button>
                            <button type="submit" className="btn btn-success btn-sm" title="Download" onClick={this.handleEstimateReimbursementReportSubmit} >
                                {this.state.isSubmitted && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isSubmitted && <span title="Download"><i className="fas fa-file-download"></i> Download</span>}
                            </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" title="Clear"
                                onClick={this.handleClearSearch}>
                                <i className="fas fa-eraser"></i> Clear
                                </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" title="Close"
                                onClick={this.handleOnCloseModal}>
                                <i className="fas fa-times"></i> Close
                                </button>
                        </div>
                    </form>
                </Modal>
                <SendEmailComponent ref="sendEmailComponent" />
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={{ of: '#panelgrid' }}
                    visible={this.state.loadPanelVisible}
                    showIndicator={true}
                    shading={false}
                    showPane={true}
                    closeOnOutsideClick={false}
                />
            </div>
        );
    }
}